module.exports = __webpack_public_path__ + "static/media/16UNODC40.2eb9cba5.jpg";